import { ESubAgentsActionTypes } from '../../actions/subAgents';
import { ERequestApiStatus, TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function subAgentsReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case ESubAgentsActionTypes.SetPending:
      return {
        ...state,
        subAgents: {
          ...state.subAgents,
          status: ERequestApiStatus.Pending,
        },
      };

    case ESubAgentsActionTypes.SetSucceed:
      return {
        ...state,
        subAgents: {
          ...state.subAgents,
          subAgentsList: action.payload.page?.offset
            ? [...state.subAgents.subAgentsList, ...action.payload.subAgentsList]
            : action.payload.subAgentsList,
          page: action.payload.page,
          status: ERequestApiStatus.Succeed,
        },
      };

    case ESubAgentsActionTypes.SetFailed:
      return {
        ...state,
        subAgents: {
          ...state.subAgents,
          status: ERequestApiStatus.Failed,
        },
      };

    case ESubAgentsActionTypes.SetSearch:
      return {
        ...state,
        subAgents: {
          ...state.subAgents,
          search: action.payload.search,
        },
      };

    default:
      return state;
  }
}
